<template>
  <div class="box">

    <a-row :gutter="24">
      <a-col :md="24">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item key="enterpriseRule">企业规则</a-menu-item>
          <a-menu-item key="standardRule">标准规则</a-menu-item>
        </a-menu>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="6">
                  <a-form-item label="规则名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入规则名称查询" v-model="queryParam.ruleName"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则编码">
                    <a-input placeholder="请输入规则名称查询" v-model="queryParam.ruleCode"/>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发码机构">
                    <a-select placeholder="请输入规则名称查询" v-model="queryParam.ruleSystem">
                      <a-select-option v-for="item in ruleSystem" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考标准">
                    <a-select placeholder="请输入规则名称查询" v-model="queryParam.ruleCategory">
                      <a-select-option v-for="item in ruleCategory" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类别">
                    <a-select placeholder="请输入规则名称查询" v-model="queryParam.ruleLabel">
                      <a-select-option v-for="item in ruleLabel" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                    <a-select placeholder="请输入规则名称查询" v-model="queryParam.status">
                      <a-select-option value="0">正常</a-select-option>
                      <a-select-option value="1">停用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="24">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="6" :sm="24">
                      <a-button type="primary" @click="searchQuery">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    </a-col>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator"  style="margin-top: 5px">
            <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
            <a-button @click="batchDel" icon="delete">删除</a-button>
          </div>

          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="uuid"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleRuleNode(record)">规则节点</a>
                <a-divider type="vertical" />
                <a @click="handleEdit2(record)">解析地址</a>
                <a-divider type="vertical" />
                <a @click="handleMakeCode(record)">生码</a>
                <a-divider type="vertical" />
                <a @click="handleMakeCodeRecord(record)">生码记录</a>
                <!-- <a-divider type="vertical" />
                <a @click="downloadFile(record)">下载</a> -->
                <a-divider type="vertical" />
                <a @click="bindTemplate(record)">绑定模板</a>
                <!-- <a-divider type="vertical" />
                <a @click="bindTraceTemplate(record)">绑定追溯模板</a> -->
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="handleCopy(record)">复制规则</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.uuid)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="customRenderFlag" slot-scope="enabled">
                <a-tag v-if="enabled==1" color="green">启用</a-tag>
                <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
              </template>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!-- 新增/编辑区域 -->
    <codeRule-modal ref="modalForm" @ok="modalFormOk" :current="current"></codeRule-modal>

    <makeCode-modal ref="modalForm2" @ok="modalFormOk"></makeCode-modal>

    <makeCodeRecord-modal ref="modalForm3" @ok="modalFormOk"></makeCodeRecord-modal>

    <ruleNode-modal ref="modalForm4" @ok="modalFormOk"></ruleNode-modal>

    <choose-template ref="chooseTemplate" @ok="chooseTemplateOk"></choose-template>

    <bind-template ref="bindTemplate" @ok="bindTemplateOk"></bind-template>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CodeRuleModal from './modules/codeRuleModal.vue';
  import RuleNodeModal from './modules/ruleNodeDrawer.vue';
  import MakeCodeModal from './modules/makeCodeModal.vue';
  import MakeCodeRecordModal from './modules/makeCodeRecordModal.vue';
  import { queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
  import ChooseTemplate from '@views/identifierCode/modules/chooseTemplate.vue'
  import BindTemplate from '@views/identifierCode/modules/bindTemplate.vue'
  import { downloadCodeList, copyRule } from '@/api/api'
  export default {
    name: "list",
    mixins:[JeecgListMixin],
    components: {
      ChooseTemplate,
      BindTemplate,
      CodeRuleModal,
      RuleNodeModal,
      MakeCodeModal,
      MakeCodeRecordModal
    },
    data() {
      return {
        current: ['enterpriseRule'], // 顶部导航栏
        bindInfo:{},
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {
          isStandard: '1'
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '5%',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '30%',
            align:"center",
            scopedSlots: { customRender: 'action' },
          },
          {title: '规则名称 ', dataIndex: 'ruleName', width: 80, align:"center",},
          {title: '规则编码 ', dataIndex: 'ruleCode', width: 80, align:"center",},
          {title: '发码机构 ', dataIndex: 'ruleSystem', width: 80, align:"center",
            customRender: (qve) => {
              if ( !qve ) {
                return '无'
              } else {
                return qve
              }
            }
          },
          {title: '参考标准 ', dataIndex: 'ruleCategory', width: 80, align:"center",
            customRender: (qve) => {
              if ( !qve ) {
                return '无'
              } else {
                return qve
              }
            }
          },
          {title: '类别', dataIndex: 'ruleLabelTxt', width: 80, align:"center"},
          {title: '更新时间 ', dataIndex: 'updateTime', width: 80, align:"center"},
          {title: '状态', dataIndex: 'status', width: 80,
            customRender: (qve) => {
              if (qve === '0') {
                return '正常';
              } else if (qve === '1') {
                return '停用';
              }
              return '未知状态';
            }
          },
        ],
        url: {
          list: "/codeRules/fzRule/list",
          delete: "/codeRules/fzRule/delete",
          deleteBatch: "/codeRules/fzRule/deleteBatch"
        },
        visibleRuleNode: false, // 规则节点抽屉开关
        uuid: '', // 每一项的uuid

        // 下拉框数据
        ruleSystem: [], // 发码机构
        ruleCategory: [], // 参考标准
        ruleLabel: [] // 类别
      }
    },
    methods: {
      handleEdit2: function (record) {
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = "解析地址"
        this.$refs.modalForm.disableSubmit = false
      },
      chooseTemplateOk(){
        this.loadData()
      },
      bindTemplate(record){
        this.$refs.chooseTemplate.open(record) // 获取生码
      },
      bindTraceTemplate(record){
        this.$refs.bindTemplate.open(record) // 绑定追溯模版
      },
      bindTemplateOk(){
        this.loadData()
      },
      // 规则节点抽屉变化事件
      afterVisibleChange(val) {
        console.log('visible', val)

      },
      // 规则节点抽屉关闭 - 点击事件
      onClose() {
        this.visibleRuleNode = false;
      },
      // 复制模版
      async handleCopy(record){
        const params = {
          ruleId: record.uuid
        }
        const res = await copyRule(params)
        if ( res.code == 200 && res.success == true ){
          this.$message.success(res.message)
          this.loadData(1)
        } else {
          this.$message.error(res.message)
        }
      }

    },
    watch: {
      current() {
        this.queryParam.isStandard = this.current[0] === 'enterpriseRule' ? '1' : '0' // 规则查询参数
        this.loadData(1)
      }
    },
    created() {
      // 获取发码机构下拉框
      queryEnableDictItemsByCode({code: 'send_code_org'})
      .then(res => {
        this.ruleSystem = res
      })
      // 获取参考标准下拉框
      queryEnableDictItemsByCode({code: 'Reference_Standards'})
      .then(res => {
        this.ruleCategory = res
      })
      // 获取类别单选框
      queryEnableDictItemsByCode({code: 'rule_code_type'})
      .then(res => {
        this.ruleLabel = res
      })
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>